'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var ANALYTICS = 'M9.15789 17H7.26316V10H9.15789V17ZM12.9474 17H11.0526V7H12.9474V17ZM16.7368 17H14.8421V13H16.7368V17ZM19.1053 19.1H4.89474V5H19.1053V19.1ZM19.1053 3H4.89474C3.85263 3 3 3.9 3 5V19C3 20.1 3.85263 21 4.89474 21H19.1053C20.1474 21 21 20.1 21 19V5C21 3.9 20.1474 3 19.1053 3Z';
var IconAnalytics = lib.variant('IconAnalytics', icon.Icon, {
    path: ANALYTICS,
});

exports.IconAnalytics = IconAnalytics;
//# sourceMappingURL=index-355cde2b.js.map
